<template>
  <sub-page
      v-model="$store.state.settings.pageData"
      :title="$t('Managers')"
      :header-action="showAddManager"
      :header-action-text="$t('Add')"
      icon="mdi-account-tie"
      >

    <template #default>
      <v-sheet class="wsRoundedHalf  mt-6">

        <v-data-table :items="managers"
                      :headers="headers"
                      class="wsHoverLight"
                      hide-default-header
        >

          <template v-slot:header="{ props }">
            <wsTableHeader :props="props" />
          </template>

        <template v-slot:item="{ item }">
          <tr @click="$router.push(businessDashLink('settings/manager/' + item.uuid))"
              class="pointer"
          >
            <td>
              <router-link class="noUnderline black--text" :to="businessDashLink('settings/manager/' + item.uuid)">
                <div class="d-flex align-center text-no-wrap">
                  <v-avatar class="mr-3"  :color="wsACCENT"
                            size="40" key="profile_picture" >
                    <v-img v-if="item.img" :src="item.img" transition="xxx" >
                      <template slot="placeholder">
                        <v-img src="@/assets/placeholder/user_blank.jpg" transition="xxx" />
                      </template>
                    </v-img>
                    <v-icon  dark v-else>mdi-account-tie</v-icon>
                  </v-avatar>
                  <div>
                    <h5> {{ item.firstname }} {{ item.lastname }}  </h5>
                    <h6 class="font-weight-light"> {{ item.email}}</h6>
                  </div>
                </div>
              </router-link>

              </td>
              <td width="10px" class="text-no-wrap">
                <wsChip icon="mdi-cogs" :color="wsACCENT" :text="$t('Permissions') + ': ' + item.permissions.length "/>
              </td>
              <td v-if="IS_BUSINESS_OWNER"
                  width="10px">
                <v-btn @click.stop="openDeleteManager(item)" icon :color="wsACCENT">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>

      </v-sheet>
    </template>

    <template #dialog>

      <!-- Display Add User dialog window -->
      <ws-user-edit-dialog
          :display="displayDialog"
          @save="addManager"
          @close="displayDialog = false"
          v-model="entityData"
          :title="$t('AddManager')"
      />

      <!-- Delete Manager Dialog-->
      <ws-dialog
          v-if="displayDelete"
          v-model="displayDelete"
          :title="$t('DeleteManager')"
          @delete="deleteManager"
          display-confirm-delete
          close-delete
          :confirm-delete-code="selectedManagerUuid"
      />


    </template>


  </sub-page>

</template>

<script>
import {mapActions, mapState} from "vuex";
import wsUserEditDialog from "@/components/UI/userEditDialog/wsUserEditDialog.vue";

export default {
  name: "BusinessDasboardManagers",
  components: {wsUserEditDialog},
  data(){
    return {
      entityData : {
        isAdmin : false,
      },
      displayDelete : false,
      selectedManagerUuid : null,
      managers : [],
      users : [],
      displayDialog : false,
      showEditPermissions : false,
      selectedManager : {},
      selectedManagerIndex : null,
      modulesPermissions : [],

      editActions : [

        { label: 'Редагувати', action: 'edit'   },
        { label: 'Видалити',   action: 'delete' },

      ],

      passwordError : false,
      emailError : false,
      phoneError : false,
      nameError : false,
      userError : false,

      reg: /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/ ,
    }
  },
  computed : {
    ...mapState('business', ['selectedBusiness']),

    headers() {
      return [
        { text : this.$t('HumanName') , value : 'name' },
        { text : this.$t('Permissions') , value : 'permissions' },
        { value : 'action' }
      ]
    },

    generalPermissionTypes() {
      return [
        { text : this.$t('Administrator'), value : true },
        { text : this.$t('LimitedRights'), value : false }
      ]
    }
  },
  methods : {
    ...mapActions( 'businessUsers', [
      'ADD_MANAGER' ,
      'DELETE_MANAGER' ,
      'GET_MANAGERS'
    ]),

    openDeleteManager(item) {
      this.selectedManagerUuid = item.uuid
      this.displayDelete = true
    },
    async deleteManager() {
      let result = await this.DELETE_MANAGER(this.selectedManagerUuid)
      if ( !result ) {
        return this.ERROR()
      }
      let index = this.managers.findIndex(el => el.uuid === this.selectedManagerUuid)
      if ( index === -1 ) {
        return
      }
      this.managers.splice(index ,  1)
      this.notify(this.$t('ManagerDeleted'))
      this.displayDelete = false
    },
    async addManager() {

      let result = await this.ADD_MANAGER(this.entityData)
      if ( !result ) {

        if ( this.$store.state.ajax.error === 'User already exist' ) {
          this.userError = true
          this.userError = true
          this.notify(this.$t('UserAlreadyExists'))
        } else {
          this.notify(this.$t('Error'))
        }

        return
      }
      this.notify(this.$t('ManagerCreated') )

      this.managers.unshift(result)
      this.displayDialog = false
    },

    showAddManager() {
      this.entityData = {}
      this.displayDialog = true
    },
    updateManagers(data){
      this.managers.unshift(data)
      this.displayDialog = false
    },

    editButton(action,item,index) {

      switch(action) {
        case 'edit'         : this.openManagerPemissions(item,index)    ; break;
        case 'delete'       : this.deleteManager(item)            ; break;
      }

    },
    openManagerPemissions(item,index) {
      this.selectedManager = item
      this.selectedManagerIndex = index
      this.showEditPermissions = true
    },

    // techical
    getPermissionName(permission){
      switch(permission) {
        case 'MODULE_NEWS'       : return 'Новини';
        case 'MODULE_PRODUCTS'   : return 'Товари';
        case 'MODULE_ORDERS'     : return 'Замовлення';
        case 'MODULE_WAREHOUSE'  : return 'Склад';
        case 'MODULE_DELIVERY'   : return 'Доставка';
        case 'MODULE_TEMPLATER'  : return 'Дизайн';
        case 'MODULE_STATISTICS' : return 'Статистика';

        default : return permission
      }
    },
    getPermissionIcon(permission){
      switch(permission) {
        case 'MODULE_NEWS'       : return 'mdi-newspaper-variant-outline';
        case 'MODULE_PRODUCTS'   : return 'mdi-cart-variant';
        case 'MODULE_ORDERS'     : return 'mdi-text-box-check-outline';
        case 'MODULE_WAREHOUSE'  : return 'mdi-warehouse';
        case 'MODULE_DELIVERY'   : return 'mdi-warehouse';
        case 'MODULE_TEMPLATER'  : return 'mdi-account';
        case 'MODULE_STATISTICS' : return 'mdi-chart-bar';

        default : return permission
      }
    }
  },
  async mounted() {

    this.loading = true
    let result = await this.GET_MANAGERS()
    if ( !result || result === true ) {
      return
    }

    this.managers = result
    this.managers.reverse()


  }

}
</script>

<style scoped>

</style>